module.exports = {"id":"167553","name":"Vitaliy Denisov","rating":"79","photo":"./data/images/photos/3/167553.png","club":{"name":"Lokomotiv Moscou","logo":"./data/images/clubs/LokomotivMoscou.png"},"positions":["DG"],"photoFolderIndex":3}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/VitaliyDenisov0.json
// module id = 4287
// module chunks = 0